export default __webpack_public_path__ + "static/media/Infra_Ready.9dc76456.png";